import { render, staticRenderFns } from "./BusinessAccount.vue?vue&type=template&id=4842c9d1&scoped=true"
import script from "./BusinessAccount.vue?vue&type=script&lang=js"
export * from "./BusinessAccount.vue?vue&type=script&lang=js"
import style0 from "./BusinessAccount.vue?vue&type=style&index=0&id=4842c9d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4842c9d1",
  null
  
)

export default component.exports